/* eslint-disable no-undef */
const isTouch = () => window?.navigator?.maxTouchPoints > 0;

const isSafari = () => 
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
        return p.toString() === '[object SafariRemoteNotification]';
    })(
        !window['safari'] ||
            (typeof safari !== 'undefined' && safari.pushNotification)
    );

export {
    isTouch,
    isSafari,
};
